/**
 * Module dependencies.
 */

import { Description } from 'components/atoms/description/description';
import { SubTitle } from 'components/atoms/sub-title/sub-title';
import styled from '@emotion/styled';

/**
 * Export `Card` styled component.
 */

export const Card = styled.div`
  border-radius: 12px;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-areas:
    'image'
    'title'
    'content';

  overflow: hidden;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);

  @media (max-width: 820px) {
    min-height: 360px;
  }

  @media (max-width: 480px) {
    min-height: 400px;
    margin: 0 24px;
    grid-template-columns: 1fr;
    grid-template-areas:
      'image'
      'title'
      'content';
  }
`;

/**
 * Export `ImageContainer` styled component.
 */

export const ImageContainer = styled.div`
  grid-area: image;
  overflow: hidden;
`;

/**
 * Export `Image` styled component.
 */

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease-in-out;

  &:hover {
    transform: scale(1.1);
  }
`;

/**
 * Export `Title` styled component.
 */

export const Title = styled(SubTitle)`
  grid-area: title;
  padding: 16px 16px 0;
`;

/**
 * Export `ProductDescription` styled component.
 */

export const ProductDescription = styled(Description)`
  grid-area: content;
  padding: 0 16px 16px;
  font-size: 14px;
  color: #555;
  line-height: 1.5;
  min-height: 100px;

  @media (max-width: 1024px) {
    min-height: initial;
  }
`;
